import { LayoutContext } from 'App/Layout/store';
import React, { useContext} from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

export default function Alert(props) {

    const layoutContext = useContext(LayoutContext);
    
    return (
      <Dialog
        fullWidth={layoutContext.state.Alert.size!=null}
        maxWidth={layoutContext.state.Alert.size?layoutContext.state.Alert.size:false}
        open={layoutContext.state.Alert.abrir}
        onClose={()=>layoutContext.dispatch({type:"resetAlert"})}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{layoutContext.state.Alert.titulo}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {layoutContext.state.Alert.contenido}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={()=>layoutContext.dispatch({type:"resetAlert"})} color="primary">
            Cerrar
          </Button>
          {layoutContext.state.Alert.sinAccion?null:
          <Button onClick={()=>{layoutContext.state.Alert.Accion();layoutContext.dispatch({type:"resetAlert"})}} color="primary" autoFocus>
          {layoutContext.state.Alert.botonAccion||"Aceptar"}
          </Button>
          }
        </DialogActions>
      </Dialog>
    );
  }